'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const reportsModule = angular
  .module('app.reports', [])
  .config(reportsConfig);

reportsConfig.$inject = ['$routeProvider'];

function reportsConfig($routeProvider) {
  $routeProvider
    .when('/sales-reports', {
      template: '<ngz-sales-reports></ngz-sales-reports>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'General Reports', icon: NAVIGATION_ICON.ASSIGNMENT }
        ]
      }
    })
    .when('/coach-reports', {
      template: '<ngz-coach-reports-list></ngz-coach-reports-list>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Coach Reports List', icon: NAVIGATION_ICON.ASSIGNMENT_IND }
        ]
      }
    });
}